import { Grid } from "@mui/material";
import { isDesktop } from "react-device-detect";
import {
  DefaultButton,
  SaveAndCancelButton,
} from "../../components/form";
import FlexBox from "../../components/layouts/Flexbox";
import {
  APP_COLORS,
  ENUM_PROJECT_STATUS,
  ENUM_USER_ROLE,
} from "../../enums";
import { JoinMeetingButton } from "../../components/form";
import {
  isTimeBetween,
} from "../../services/utils/date-and-time.utils";
import {
  isCancelledOrRejected as isProjectCancelledOrRejected,
} from "../my-projects/utils";
import { useAppSelector } from "../../store";

const VENDOR_ROLES = [
  ENUM_USER_ROLE.OPPORTUNITY_VENDOR,
  ENUM_USER_ROLE.VENDOR,
  ENUM_USER_ROLE.DELEGATE_VENDOR,
];

export default function ProjectDetailsActionButtons({
  projectDetails,
  submitting,
  onSave,
  onCancel,
  onSendClick,
  onRejectClick,
  onAmbassadorSlotSubmit,
  ambassadorSelectedSlot,
  checkIfApprovable,
  onMarkAsCompletedClick,
  onCancelledClick,
  onAddTimeslotClick,
}) {
  const userData = useAppSelector((state) => state.auth.user);

  const isCancelledOrRejected = isProjectCancelledOrRejected(projectDetails);

  const renderRejectButton = () => {
    return (
      <DefaultButton
        onClick={onRejectClick}
        sx={{
          border: `1px solid ${APP_COLORS.error}`,
          color: APP_COLORS.error,
        }}
        fullWidth={!isDesktop}
      >
        Reject
      </DefaultButton>
    );
  };

  const renderCloseButton = () => {
    return (
      <DefaultButton onClick={onCancel} fullWidth={!isDesktop}>Close</DefaultButton>
    );
  };

  if (isCancelledOrRejected) {
    return renderCloseButton();
  }

  return (
    <>
      {isTimeBetween(
        projectDetails?.selectedTimeSlot?.from,
        projectDetails?.selectedTimeSlot?.to
      ) &&
        projectDetails?.status === ENUM_PROJECT_STATUS.SEND_MEETING_LINK && (
          <Grid container justifyContent={"flex-end"}>
            <JoinMeetingButton url={projectDetails?.zoomURL} />
          </Grid>
        )}
      {projectDetails?.status === ENUM_PROJECT_STATUS.REQUESTED &&
        ENUM_USER_ROLE.AMBASSADOR === userData.role && (
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={6}>
              {renderRejectButton()}
            </Grid>
            <Grid item xs={6}>
              <SaveAndCancelButton
                loading={submitting}
                onActionButtonClick={onSave}
                primaryButtonText="Submit"
                secondaryButtonText="Close"
                onCancelButtonClick={onCancel}
                primaryButtonProps={{
                  ...(checkIfApprovable() === true && { disabled: true }),
                }}
              />
            </Grid>
          </Grid>
        )}
      {((projectDetails?.status === ENUM_PROJECT_STATUS.REQUESTED &&
        VENDOR_ROLES.includes(userData.role)) ||
        projectDetails?.status === ENUM_PROJECT_STATUS.DONE ||
        projectDetails?.status === ENUM_PROJECT_STATUS.REJECTED) && (
          <Grid
            container
            justifyContent={
              projectDetails?.status !== ENUM_PROJECT_STATUS.DONE &&
                projectDetails?.status !== ENUM_PROJECT_STATUS.REJECTED
                ? "space-between"
                : "flex-end"
            }
          >
            {renderCloseButton()}
          </Grid>
        )}
      {projectDetails?.status === ENUM_PROJECT_STATUS.RESPONDED &&
        VENDOR_ROLES.includes(userData.role) && (
          <Grid container justifyContent={"flex-end"}>
            <Grid item xs={6}>
              <SaveAndCancelButton
                loading={submitting}
                primaryButtonText="Approve"
                secondaryButtonText="Reject"
                secondaryButtonProps={{
                  sx: {
                    border: `1px solid ${APP_COLORS.error}`,
                    color: APP_COLORS.error,
                  },
                }}
                onActionButtonClick={onSendClick}
                onCancelButtonClick={onRejectClick}
              />
            </Grid>
          </Grid>
        )}
      {projectDetails?.status === ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT &&
        ENUM_USER_ROLE.AMBASSADOR === userData.role && (
          <Grid container justifyContent={"flex-end"}>
            {renderCloseButton()}
          </Grid>
        )}
      {projectDetails?.status === ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT &&
        VENDOR_ROLES.includes(userData.role) && (
          <Grid container justifyContent={"space-between"} spacing={1}>
            <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
              {renderRejectButton()}
            </Grid>
            <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
              <SaveAndCancelButton
                loading={submitting}
                onActionButtonClick={onAddTimeslotClick}
                primaryButtonText="Next"
                secondaryButtonText="Close"
                onCancelButtonClick={onCancel}
              />
            </Grid>
          </Grid>
        )}
      {projectDetails?.status === ENUM_PROJECT_STATUS.RESPONDED &&
        ENUM_USER_ROLE.AMBASSADOR === userData.role && (
          <FlexBox justifyContent={"space-between"} gap={1}>
            {renderRejectButton()}
            {renderCloseButton()}
          </FlexBox>
        )}
      {projectDetails?.status ===
        ENUM_PROJECT_STATUS.ADDED_TIME_SLOTS_BY_CLIENT &&
        ENUM_USER_ROLE.AMBASSADOR === userData.role && (
          <Grid container justifyContent={"flex-end"} spacing={1}>
              <SaveAndCancelButton
                loading={submitting}
                onActionButtonClick={onAmbassadorSlotSubmit}
                primaryButtonText="Submit"
                secondaryButtonText="Close"
                onCancelButtonClick={onCancel}
                primaryButtonProps={{
                  disabled: !ambassadorSelectedSlot,
                }}
              />
          </Grid>
        )}
      {projectDetails?.status ===
        ENUM_PROJECT_STATUS.ADDED_TIME_SLOTS_BY_CLIENT &&
        VENDOR_ROLES.includes(userData.role) && (
          <FlexBox justifyContent={"flex-end"}>
            {renderCloseButton()}
          </FlexBox>
        )}
      {projectDetails?.status ===
        ENUM_PROJECT_STATUS.SELECTED_TIME_SLOT_BY_AMBASSADOR &&
        ENUM_USER_ROLE.AMBASSADOR === userData.role && (
          <FlexBox justifyContent={"flex-end"} gap={1}>
            {renderCloseButton()}
          </FlexBox>
        )}
    </>
  );
}
